import { addedNewNotifacationSuccess, setClearNotification } from './actionCreator'

export const addedNewNotification = (notification) => (
  dispatch => {
    dispatch(addedNewNotifacationSuccess(notification))
    dispatch(setClearNotification())
  }
)